import React from "react";
import MovieCard from "./MovieCard";

function FavouriteMovies({ favourites, toggleFavourite }) {

  if (favourites.length === 0) {
    return <p>No favourite movies yet.</p>;
  }

  return (
    <div>

      <h2>Favourite Movies</h2>

      <div className="movie-list">

        {favourites.map(movie => (
          <MovieCard
            key={movie.id}
            movie={movie}
            toggleFavourite={toggleFavourite}
            isFavourite={true}
          />
        ))}

      </div>

    </div>
  );
}

export default FavouriteMovies;